import { render, staticRenderFns } from "./ModalRegisterRoom.vue?vue&type=template&id=edd471c6&scoped=true"
import script from "./ModalRegisterRoom.vue?vue&type=script&lang=js"
export * from "./ModalRegisterRoom.vue?vue&type=script&lang=js"
import style0 from "./ModalRegisterRoom.vue?vue&type=style&index=0&id=edd471c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd471c6",
  null
  
)

export default component.exports